"use strict";

var _classCallCheck = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disassemble = exports.chunkArray = void 0;
;

var opcodes_1 = require("./opcodes");

function toHex8(v) {
  return "".concat(v.toString(16).toUpperCase().padStart(2, '0'));
}

function toHex16(v) {
  return "".concat(v.toString(16).toUpperCase().padStart(4, '0'));
}

function chunkArray(myArray, chunk_size) {
  var index = 0;
  var arrayLength = myArray.length;
  var tempArray = [];

  for (index = 0; index < arrayLength; index += chunk_size) {
    var myChunk = myArray.slice(index, index + chunk_size);
    tempArray.push(myChunk);
  }

  return tempArray;
}

exports.chunkArray = chunkArray;

function cycles(cycleBits, crossesPage) {
  var cycles = cycleBits & 63;
  var cycleMods = cycleBits >> 6;

  if (cycleMods === 1 || cycleMods === 2) {
    return "".concat(cycles, "/").concat(cycles + 1);
  } else if (cycleMods === 3) {
    if (crossesPage) {
      return "".concat(cycles + 1, "/").concat(cycles + 2);
    } else {
      return "".concat(cycles, "/").concat(cycles + 1);
    }
  }

  return "".concat(cycles);
}

var Disassembler = /*#__PURE__*/function () {
  function Disassembler(buf, labels, disasmOptions) {
    var _this = this;

    _classCallCheck(this, Disassembler);

    var _a;

    this.buf = buf;
    this.outputPadChars = '     ';
    this.outputBytesPerLine = 1;
    this.bytes = {
      startPC: 0,
      bytes: []
    };
    this.labelsDict = {};

    this.byte = function () {
      var b = _this.buf.readUInt8(_this.curOffs);

      _this.curOffs++;
      return b;
    };

    this.print = function (addr, bytes, decoded, label, cycle) {
      var _a, _b;

      _this.flushBytes();

      var b0 = toHex8(bytes[0]);
      var b1 = bytes.length >= 2 ? toHex8(bytes[1]) : '  ';
      var b2 = bytes.length >= 3 ? toHex8(bytes[2]) : '  ';
      var line = "".concat(toHex16(addr), ": ").concat(b0, " ").concat(b1, " ").concat(b2).concat(_this.outputPadChars).concat(decoded);
      var showCycles = (_a = _this.disasmOptions) === null || _a === void 0 ? void 0 : _a.showCycles;
      var showLabels = (_b = _this.disasmOptions) === null || _b === void 0 ? void 0 : _b.showLabels;

      if (showCycles || showLabels) {
        var elts = [];

        if (showCycles) {
          elts.push(cycle);
        }

        if (showLabels) {
          elts.push(label);
        }

        _this.output.push("".concat(line.padEnd(50), "; ").concat(elts.join(' ')));
      } else {
        _this.output.push(line);
      }
    };

    this.output = [];
    this.curAddr = buf.readUInt8(0) + (buf.readUInt8(1) << 8);
    this.curOffs = 2;
    this.disasmOptions = disasmOptions;
    this.labels = labels;

    if ((_a = this.disasmOptions) === null || _a === void 0 ? void 0 : _a.isInstruction) {
      this.outputPadChars = '                    ';
      this.outputBytesPerLine = 8;
    }

    if (this.labels) {
      this.labels.forEach(function (_ref) {
        var name = _ref.name,
            addr = _ref.addr,
            size = _ref.size;
        _this.labelsDict[addr] = name;
      });
    }

    this.opToDecl = {};
    Object.keys(opcodes_1.default).forEach(function (key) {
      var decl = opcodes_1.default[key];

      for (var i = 0; i < decl.length; i++) {
        var d = decl[i];

        if (d !== null) {
          var decode = decl.map(function (e) {
            return e !== null ? e & 255 : null;
          });
          _this.opToDecl[d & 255] = {
            mnemonic: key,
            decode: decode,
            cycles: d >> 8
          };
        }
      }
    });
  }

  _createClass(Disassembler, [{
    key: "flushBytes",
    value: function flushBytes() {
      var chunks = chunkArray(this.bytes.bytes, this.outputBytesPerLine);
      var pc = this.bytes.startPC;

      for (var i = 0; i < chunks.length; i++, pc += this.outputBytesPerLine) {
        var bytes = chunks[i];
        var bstr = bytes.map(function (b) {
          return toHex8(b);
        }).join(' ');
        this.output.push("".concat(toHex16(pc), ": ").concat(bstr));
      }

      this.bytes.bytes = [];
    }
  }, {
    key: "disImm",
    value: function disImm(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var imm = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, imm], "".concat(mnemonic, " #$").concat(toHex8(imm)), label, cycle);
    }
  }, {
    key: "disZp",
    value: function disZp(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var zp = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, zp], "".concat(mnemonic, " $").concat(toHex8(zp)), label, cycle);
    }
  }, {
    key: "disZpX",
    value: function disZpX(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var zp = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, zp], "".concat(mnemonic, " $").concat(toHex8(zp), ",X"), label, cycle);
    }
  }, {
    key: "disZpY",
    value: function disZpY(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var zp = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, zp], "".concat(mnemonic, " $").concat(toHex8(zp), ",Y"), label, cycle);
    }
  }, {
    key: "disAbs",
    value: function disAbs(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var lo = this.byte();
      var hi = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, lo, hi], "".concat(mnemonic, " $").concat(toHex16(lo + hi * 256)), label, cycle);
    }
  }, {
    key: "disAbsX",
    value: function disAbsX(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var lo = this.byte();
      var hi = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, lo, hi], "".concat(mnemonic, " $").concat(toHex16(lo + hi * 256), ",X"), label, cycle);
    }
  }, {
    key: "disAbsY",
    value: function disAbsY(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var lo = this.byte();
      var hi = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, lo, hi], "".concat(mnemonic, " $").concat(toHex16(lo + hi * 256), ",Y"), label, cycle);
    }
  }, {
    key: "disInd",
    value: function disInd(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var lo = this.byte();
      var hi = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, lo, hi], "".concat(mnemonic, " ($").concat(toHex16(lo + hi * 256), ")"), label, cycle);
    }
  }, {
    key: "disIndX",
    value: function disIndX(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var lo = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, lo], "".concat(mnemonic, " ($").concat(toHex8(lo), ",X)"), label, cycle);
    }
  }, {
    key: "disIndY",
    value: function disIndY(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var lo = this.byte();
      var cycle = cycles(cycleBits);
      this.print(addr, [op, lo], "".concat(mnemonic, " ($").concat(toHex8(lo), "),Y"), label, cycle);
    }
  }, {
    key: "disSingle",
    value: function disSingle(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var cycle = cycles(cycleBits);
      this.print(addr, [op], "".concat(mnemonic), label, cycle);
    }
  }, {
    key: "disBranch",
    value: function disBranch(mnemonic, op, label, cycleBits) {
      var addr = this.curAddr;
      var lo = this.byte();
      var bofs = lo >= 128 ? -(256 - lo) : lo;
      var tgt = addr + bofs + 2;
      var crossesPage = (addr + 2 & ~0xff) != (tgt & ~0xff);
      var cycle = cycles(cycleBits, crossesPage);
      this.print(addr, [op, lo], "".concat(mnemonic, " $").concat(toHex16(tgt)), label, cycle);
    }
  }, {
    key: "disUnknown",
    value: function disUnknown(op) {
      if (this.bytes.bytes.length !== 0) {
        this.bytes.bytes.push(op);
      } else {
        this.bytes.bytes = [op];
        this.bytes.startPC = this.curAddr;
      }
    }
  }, {
    key: "disassemble",
    value: function disassemble() {
      var len = this.buf.byteLength;

      var isInsn = function isInsn(addr) {
        return true;
      };

      if (this.disasmOptions && this.disasmOptions.isInstruction) {
        isInsn = this.disasmOptions.isInstruction;
      }

      var oldOffs = this.curOffs;

      while (this.curOffs < len) {
        this.curAddr += this.curOffs - oldOffs;
        var label = "";

        if (this.curAddr in this.labelsDict) {
          label = this.labelsDict[this.curAddr];
        }

        oldOffs = this.curOffs;
        var op = this.byte();
        var decl = this.opToDecl[op];

        if (isInsn(this.curAddr) && decl !== undefined) {
          var decoderIdx = decl.decode.indexOf(op);
          var cycleBits = decl.cycles;

          if (decoderIdx === 0) {
            this.disImm(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 1) {
            this.disZp(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 2) {
            this.disZpX(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 3) {
            this.disZpY(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 4) {
            this.disAbs(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 5) {
            this.disAbsX(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 6) {
            this.disAbsY(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 7) {
            this.disInd(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 8) {
            this.disIndX(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 9) {
            this.disIndY(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 10) {
            this.disSingle(decl.mnemonic, op, label, cycleBits);
            continue;
          }

          if (decoderIdx === 11) {
            this.disBranch(decl.mnemonic, op, label, cycleBits);
            continue;
          }
        } else {
          this.disUnknown(op);
        }
      }

      this.flushBytes();
      return this.output;
    }
  }]);

  return Disassembler;
}();

function disassemble(prg, labels, options) {
  var disasm = new Disassembler(prg, labels, options);
  return disasm.disassemble();
}

exports.disassemble = disassemble;